const translations = {
	unitTest: "pt_br_unit_test",
	welcome: "Bem Vindo",

	signIn: "Entrar",
	language: "Idioma",
	signInRequired: "Login Necessário",
	signInRequiredDescription:
		"Você precisa fazer login para acessar o painel administrativo.",

	selectTheme: "Selecionar Tema",

	// Roles
	roles: {
		SUPER_ADMIN: "Super Administrador",
		SUPPORT_ADMIN: "Administrador de Suporte",
		ANALYTICS_VIEWER: "Visualizador de Análises",
		USER_MANAGER: "Gerenciador de Usuários",
	},

	// Dashboard
	dashboard: {
		title: "Painel",
		kpis: {
			title: "Visão Geral da Plataforma",
			totalOrganizations: "Organizações",
			totalUsers: "Usuários",
		},
		activeSubscriptions: {
			title: "Assinaturas Ativas",
			subtitle: "Organizações por tipo de plano",
			starter: "Inicial",
			professional: "Profissional",
			enterprise: "Empresarial",
			total: "Total",
		},
		revenueChart: {
			title: "Tendência de Receita",
			subtitle: "Receita mensal nos últimos 12 meses",
			noData: "Dados de receita não disponíveis",
		},
	},

	// Common
	common: {
		loading: "Loading...",
		cancel: "Cancel",
		save: "Save",
		back: "Voltar",
		goHome: "Ir para Home",
		retry: "Tentar novamente",
		error: "Erro",
		errors: {
			generic: "Algo deu errado. Por favor, tente novamente.",
		},
	},

	// Users
	users: {
		title: "Usuários",
		table: {
			email: "Email",
			name: "Nome",
			role: "Função",
			status: "Status",
			createdAt: "Criado em",
			actions: "Ações",
		},
		roles: {
			super_admin: "Super Administrador",
			support_admin: "Administrador de Suporte",
			analytics_viewer: "Visualizador de Análises",
			user_manager: "Gerenciador de Usuários",
		},
		status: {
			active: "Ativo",
			inactive: "Inativo",
		},
		empty: {
			title: "Nenhum usuário encontrado",
			description: "Não há usuários para exibir.",
		},
		editRole: {
			title: "Editar Função do Usuário",
			description: "Alterar a função de {{email}}",
			selectRole: "Selecionar Função",
		},
		toasts: {
			updatingRole: "Atualizando função do usuário...",
			updateRoleSuccess: "Função do usuário atualizada com sucesso",
			updateRoleError: "Falha ao atualizar função do usuário",
		},
	},

	// Organizations
	organizations: {
		title: "Organizações",
		table: {
			name: "Nome",
			description: "Descrição",
			language: "Idioma",
			currency: "Moeda",
			trialAvailable: "Trial Disponível",
			createdAt: "Criado em",
		},
		trial: {
			yes: "Sim",
			no: "Não",
		},
		empty: {
			title: "Nenhuma organização encontrada",
			description: "Não há organizações para exibir.",
		},
		details: {
			title: "Detalhes da Organização",
			description: "Visualizar e gerenciar informações da organização",
			overview: {
				title: "Visão Geral",
				description: "Visão geral da organização e informações principais",
			},
			owner: {
				title: "Proprietário",
				description: "Informações do proprietário da organização",
				noOwner: "Nenhum proprietário atribuído",
			},
			info: {
				name: "Nome",
				description: "Descrição",
				language: "Idioma Padrão",
				currency: "Moeda Padrão",
				trialAvailable: "Trial Disponível",
				platformCustomerId: "ID do Cliente na Plataforma",
				createdAt: "Criado em",
				updatedAt: "Atualizado em",
				noDescription: "Sem descrição disponível",
			},
		},
		navigation: {
			overview: "Visão Geral",
		},
		actions: {
			resetTrial: "Resetar Trial",
		},
		toasts: {
			resettingTrial: "Resetando trial...",
			resetTrialSuccess: "Trial resetado com sucesso",
			resetTrialError: "Falha ao resetar trial",
		},
	},

	// Support Tickets
	supportTickets: {
		title: "Tickets de Suporte",
		ticketId: "ID do Ticket",
		ticketInformation: "Informações do Ticket",
		description: "Descrição",
		comments: "Comentários",
		noComments: "Nenhum comentário ainda",
		addComment: "Adicionar Comentário",
		commentPlaceholder: "Escreva seu comentário aqui...",
		sendComment: "Enviar Comentário",
		commentSubmitting: "Enviando...",
		addingComment: "Adicionando comentário...",
		commentAdded: "Comentário adicionado com sucesso!",
		commentError: "Erro ao adicionar comentário. Tente novamente.",
		staff: "Equipe",
		staffTeam: "Equipe de Suporte",
		user: "Usuário",
		table: {
			title: "Título",
			user: "Usuário",
			type: "Tipo",
			status: "Status",
			createdAt: "Criado em",
		},
		types: {
			suggestion: "Sugestão",
			request: "Solicitação",
			complaint: "Reclamação",
		},
		statuses: {
			open: "Aberto",
			waiting_for_user: "Aguardando Usuário",
			waiting_for_staff: "Aguardando Equipe",
			resolved: "Resolvido",
			closed: "Fechado",
		},
		empty: {
			title: "Nenhum ticket de suporte encontrado",
			description: "Não há tickets de suporte para exibir.",
		},
	},

	// Settings
	settings: {
		title: "Configurações",
		description: "Gerenciar configurações da plataforma",
		navigation: {
			adminUsers: "Usuários Admin",
		},
		adminUsers: {
			empty: {
				title: "Nenhum usuário admin encontrado",
				description: "Não há usuários admin para exibir.",
			},
		},
	},
	platformPlans: {
		title: "Planos da Plataforma",
		list: {
			create: "Criar plano",
			showArchived: "Mostrar arquivados",
		},
		new: {
			title: "Novo plano da plataforma",
		},
		detail: {
			formTitle: "Detalhes do plano",
			archive: "Arquivar plano",
			subscriptionsInfo:
				"Este plano possui {{count}} assinatura(s) ativa(s). Não pode ser arquivado até que todas as assinaturas sejam movidas para outro plano.",
			archiveDialog: {
				title: "Arquivar plano",
				description:
					'Tem certeza de que deseja arquivar "{{name}}"? Planos arquivados ficam ocultos para novos cadastros, mas as assinaturas existentes são preservadas.',
			},
		},
		empty: {
			title: "Nenhum plano da plataforma encontrado",
			description: "Crie seu primeiro plano da plataforma para começar.",
		},
		status: {
			active: "Ativo",
			archived: "Arquivado",
		},
		table: {
			name: "Nome",
			slug: "Slug",
			tier: "Nível",
			monthly: "Mensal",
			yearly: "Anual",
			status: "Status",
			subscriptions: "Assinaturas",
			defaultBadge: "Padrão",
		},
		form: {
			name: "Nome",
			slug: "Slug",
			slugHint:
				"Letras minúsculas, números e hifens. Não pode ser alterado após a criação.",
			tier: "Nível",
			description: "Descrição",
			currency: "Moeda",
			monthly: "Preço mensal (centavos)",
			yearly: "Preço anual (centavos)",
			priceHint:
				"Os preços são armazenados na menor unidade da moeda (centavos).",
			trialDays: "Dias de teste",
			isActive: "Ativo",
			isDefault: "Plano padrão",
			providerPriceIds: "IDs de preço dos provedores",
			providerPriceIdsEmpty:
				"Nenhum ID de preço configurado. Adicione um para vincular este plano a um provedor de pagamento.",
			providerPlaceholder: "stripe",
			cyclePlaceholder: "monthly",
			priceIdPlaceholder: "price_xxx",
			addPriceId: "Adicionar ID de preço",
			submitCreate: "Criar plano",
			submitUpdate: "Salvar alterações",
			errors: {
				nameRequired: "O nome é obrigatório",
				slugInvalid:
					"O slug deve ser alfanumérico minúsculo, com hifens opcionais",
				monthlyInvalid:
					"O preço mensal deve ser um número inteiro não negativo",
				yearlyInvalid: "O preço anual deve ser um número inteiro não negativo",
				trialInvalid:
					"Os dias de teste devem ser um número inteiro não negativo",
				tierInvalid: "O nível deve ser um número inteiro",
			},
		},
		entitlements: {
			title: "Direitos",
			feature: "Funcionalidade",
			enabled: "Habilitado",
			limitType: "Tipo de limite",
			limitValue: "Valor do limite",
			save: "Salvar direitos",
			limitTypes: {
				BOOLEAN: "Booleano",
				QUANTITY: "Quantidade",
				UNLIMITED: "Ilimitado",
			},
			errors: {
				quantityRequired:
					"É necessário informar uma quantidade não negativa para a funcionalidade {{code}}",
			},
		},
		featureCodes: {
			medical_records: "Prontuários médicos",
			customer_import: "Importação de clientes",
			analytics_dashboard: "Painel de análises",
			custom_branding: "Personalização de marca",
			priority_support: "Suporte prioritário",
			max_establishments: "Máximo de estabelecimentos",
			max_staff_members: "Máximo de membros da equipe",
			max_customers: "Máximo de clientes",
			max_schedules_per_month: "Máximo de agendamentos por mês",
			llm_access: "Acesso a LLM",
			llm_tokens_per_month: "Tokens de LLM por mês",
		},
		toasts: {
			creating: "Criando plano...",
			createSuccess: "Plano criado",
			createError: "Falha ao criar plano",
			updating: "Salvando plano...",
			updateSuccess: "Plano salvo",
			updateError: "Falha ao salvar plano",
			archiving: "Arquivando plano...",
			archiveSuccess: "Plano arquivado",
			archiveError: "Falha ao arquivar plano",
			savingEntitlements: "Salvando direitos...",
			saveEntitlementsSuccess: "Direitos salvos",
			saveEntitlementsError: "Falha ao salvar direitos",
		},
	},
};

export default translations;
